import React, { useMemo } from 'react';

import { useAuth } from '../../hooks/auth';
import Content from './Content';
import navigation from './navigation';
import Sidebar from './Sidebar';

// import { Container } from './styles';

function layout({ children }) {
  const { loggedUser } = useAuth();
  const items = useMemo(
    () => navigation.filter(
      (item) => item.to !== '/admin/painel' || loggedUser?.type === 'super-admin',
    ),
    [loggedUser?.type],
  );

  return (
    <div className="d-flex" style={{ height: '130vh' }}>
      <Sidebar items={items} />
      <Content>
        {children}
      </Content>
    </div>
  );
}

export default layout;
